
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { selectAccessToken } from '../modules/login';

const PrivateRoute: React.FC = () => {
  const accessToken = useSelector(selectAccessToken);

  return accessToken ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
